export const getCategoryData =(store)=>store.category.category
